import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { dataExportService } from "../services/data-export-service";
import type {
	ExportResponse,
	GenerateReportRequest,
} from "../types/generate-report-request";
import {
	getExportErrorMessage,
	isExportNoDataError,
} from "../utils/get-export-error-message";

type ExportMutationOptions = {
	onSuccess?: (response: ExportResponse) => void;
};

function handleExportError(error: unknown) {
	const isNoData = isExportNoDataError(error);

	toast(
		ToastCustom({
			description: getExportErrorMessage(error),
			title: isNoData ? "Atenção" : "Erro",
			variant: isNoData ? "warning" : "error",
		})
	);
}

export function useExportReport(options?: ExportMutationOptions) {
	return useMutation({
		mutationFn: (payload: GenerateReportRequest) =>
			dataExportService.exportReport(payload),
		onSuccess: (response) => {
			options?.onSuccess?.(response);
		},
		onError: handleExportError,
	});
}

export function useExportVehicles(options?: ExportMutationOptions) {
	return useExportReport(options);
}

export function useExportInfractions(options?: ExportMutationOptions) {
	return useExportReport(options);
}

export function useExportChecklists(options?: ExportMutationOptions) {
	return useExportReport(options);
}

export function useExportExpenses(options?: ExportMutationOptions) {
	return useExportReport(options);
}

export function useExportEvents(options?: ExportMutationOptions) {
	return useExportReport(options);
}
